"use client";

import { useEffect } from "react";
import { useTranslations } from "next-intl";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const tc = useTranslations("common");
  const ta = useTranslations("about");
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center px-4">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">
          {tc("error")}
        </h1>
        <p className="text-gray-600 mb-6">
          {ta("errorLoadPage")}
        </p>
        <button
          onClick={() => reset()}
          className="bg-[#e4002b] text-white px-6 py-3 rounded-sm font-semibold hover:opacity-90 transition-opacity"
        >
          {tc("tryAgain")}
        </button>
      </div>
    </main>
  );
}
